import baseApi from './base.api'
import { normalizeFetchOrganizationsResponse } from './utils/normalizers/organization.api.normalizers'
import { ORGANIZATION_TAG } from './utils/tags'

export const organizationApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        createOrganization: builder.mutation({
            query: ({ name }) => ({
                url: `/organization`,
                method: 'POST',
                body: { account_name: name },
            }),
            invalidatesTags: [{ type: ORGANIZATION_TAG, id: 'LIST' }],
        }),
        fetchOrganizations: builder.query({
            query: () => ({
                url: `/users/accounts`,
                method: 'GET',
            }),
            transformResponse: normalizeFetchOrganizationsResponse,
            providesTags: [{ type: ORGANIZATION_TAG, id: 'LIST' }],
        }),
    }),
})

export const { useFetchOrganizationsQuery, useCreateOrganizationMutation } = organizationApi
